<template>
    <div class="mt-5 mb-10">
        <section>
            <v-row>
                <v-col cols="12" md="4">
                    <v-card flat class="mb-4">
                        <v-card-text class="d-flex align-center gap-15 pa-3">
                            <div>
                                <v-img
                                    :src="require('@/assets/apps/chat.svg')"
                                    height="45"
                                    width="45"
                                />
                            </div>
                            <div>
                                <div class="grey--text font-size-12">
                                    Total Aktivitas Konsul
                                </div>
                                <div
                                    class="font-weight-bold black--text mt-1 font-size-24"
                                >
                                    {{ formatNumber(data.total_consul) }}
                                    <span class="font-size-12 font-weight-500">
                                        Aktivitas
                                    </span>
                                </div>
                            </div>
                        </v-card-text>
                    </v-card>
                </v-col>

                <v-col cols="12" md="4">
                    <v-card flat>
                        <v-card-text class="d-flex align-center gap-10 pa-3">
                            <div>
                                <v-img
                                    :src="require('@/assets/apps/bell.svg')"
                                    height="45"
                                    width="45"
                                />
                            </div>
                            <div>
                                <div class="grey--text font-size-12">
                                    Status Started
                                </div>
                                <div
                                    class="font-weight-bold black--text mt-1 font-size-24"
                                >
                                    {{
                                        formatNumber(data.total_consul_started)
                                    }}
                                    <span class="font-size-12 font-weight-500">
                                        Started
                                    </span>
                                </div>
                            </div>
                        </v-card-text>
                    </v-card>
                </v-col>

                <v-col cols="12" md="4">
                    <v-card flat>
                        <v-card-text class="d-flex align-center gap-10 pa-3">
                            <div>
                                <v-img
                                    :src="require('@/assets/apps/waiting.svg')"
                                    height="45"
                                    width="45"
                                />
                            </div>
                            <div>
                                <div class="grey--text font-size-12">
                                    Status Waiting
                                </div>
                                <div
                                    class="font-weight-bold black--text mt-1 font-size-24"
                                >
                                    {{
                                        formatNumber(data.total_consul_waiting)
                                    }}
                                    <span class="font-size-12 font-weight-500">
                                        Waiting
                                    </span>
                                </div>
                            </div>
                        </v-card-text>
                    </v-card>
                </v-col>

                <v-col cols="12" md="4">
                    <v-card flat>
                        <v-card-text class="d-flex align-center gap-10 pa-3">
                            <div>
                                <v-img
                                    :src="require('@/assets/apps/finish.svg')"
                                    height="45"
                                    width="45"
                                />
                            </div>
                            <div>
                                <div class="grey--text font-size-12">
                                    Status Finished
                                </div>
                                <div
                                    class="font-weight-bold black--text mt-1 font-size-24"
                                >
                                    {{
                                        formatNumber(data.total_consul_finished)
                                    }}
                                    <span class="font-size-12 font-weight-500">
                                        Finished
                                    </span>
                                </div>
                            </div>
                        </v-card-text>
                    </v-card>
                </v-col>

                <v-col cols="12" md="4">
                    <v-card flat>
                        <v-card-text class="d-flex align-center gap-10 pa-3">
                            <div>
                                <v-img
                                    :src="require('@/assets/apps/canceled.svg')"
                                    height="45"
                                    width="45"
                                />
                            </div>
                            <div>
                                <div class="grey--text font-size-12">
                                    Status Canceled
                                </div>
                                <div
                                    class="font-weight-bold black--text mt-1 font-size-24"
                                >
                                    {{
                                        formatNumber(data.total_consul_canceled)
                                    }}
                                    <span class="font-size-12 font-weight-500">
                                        Canceled
                                    </span>
                                </div>
                            </div>
                        </v-card-text>
                    </v-card>
                </v-col>

                <v-col cols="12" md="4">
                    <v-card flat>
                        <v-card-text class="d-flex align-center gap-10 pa-3">
                            <div>
                                <v-img
                                    :src="require('@/assets/apps/timeout.svg')"
                                    height="45"
                                    width="45"
                                />
                            </div>
                            <div>
                                <div class="grey--text font-size-12">
                                    Status Timeout
                                </div>
                                <div
                                    class="font-weight-bold black--text mt-1 font-size-24"
                                >
                                    {{
                                        formatNumber(data.total_consul_timeout)
                                    }}
                                    <span class="font-size-12 font-weight-500">
                                        Timeout
                                    </span>
                                </div>
                            </div>
                        </v-card-text>
                    </v-card>
                </v-col>
            </v-row>
        </section>
    </div>
</template>

<script>
export default {
    name: "consultant-management-statistic",
    props: {
        data: { type: Array, required: true },
    },
    data() {
        return {
            loading: false,
            data: [],
        };
    },

    methods: {
        formatNumber(value = 0) {
            return new Intl.NumberFormat("id-ID", {
                maximumFractionDigits: 0,
            }).format(value);
        },
    },
};
</script>



// WEBPACK FOOTER //
// ConsulActivityStatistic.vue?725aabea